import React, { useState } from 'react';
import { SystemSettings } from '../types';
import { saveSettings } from '../utils/db';

interface SettingsFormProps {
  currentSettings: SystemSettings;
  onSettingsSaved: (newSettings: SystemSettings) => void;
}

const SettingsForm: React.FC<SettingsFormProps> = ({ currentSettings, onSettingsSaved }) => {
  const [totalSeats, setTotalSeats] = useState<number>(currentSettings.totalSeats);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isFormVisible, setIsFormVisible] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (totalSeats < 1) {
      setError('席数は1以上の数値を入力してください');
      return;
    }
    
    setError(null);
    setIsSubmitting(true);
    
    try {
      const newSettings = await saveSettings({ totalSeats });
      onSettingsSaved(newSettings);
      setIsFormVisible(false);
    } catch (err) {
      console.error('設定の保存に失敗しました:', err);
      setError(err instanceof Error ? err.message : '設定の保存に失敗しました。もう一度お試しください。');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="settings-form-container">
      <button 
        onClick={() => setIsFormVisible(!isFormVisible)}
        className="settings-toggle-button"
      >
        {isFormVisible ? '設定を閉じる' : '設定を開く'}
      </button>
      
      {isFormVisible && (
        <div className="settings-form">
          <h3>システム設定</h3>
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="totalSeats">最大席数</label>
              <input
                type="number"
                id="totalSeats"
                min="1"
                value={totalSeats}
                onChange={(e) => setTotalSeats(parseInt(e.target.value, 10) || 0)}
                disabled={isSubmitting}
                required
              />
              <small>抽選可能な最大席数を設定します</small>
            </div>
            
            {error && <div className="error-message">{error}</div>}
            
            <div className="settings-actions">
              <button 
                type="button" 
                onClick={() => setIsFormVisible(false)}
                className="cancel-button"
                disabled={isSubmitting}
              >
                キャンセル
              </button>
              <button 
                type="submit" 
                disabled={isSubmitting}
                className="save-button"
              >
                {isSubmitting ? '保存中...' : '設定を保存'}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default SettingsForm; 